var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq42(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.524609,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7609,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.3484,
    y1: 12.1824,
    x2: 49.5847,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.674587,
    y1: 49.8543,
    x2: 11.9109,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.1106,
    y1: 38.6199,
    x2: 49.3469,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.436741,
    y1: 0.944118,
    x2: 11.6731,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.476 27.62V26.878L21.572 20.018H22.734V26.766H24.232V27.62H22.734V30H21.768V27.62H16.476ZM21.81 21.096L17.61 26.766H21.81V21.096ZM25.2999 29.23C27.0173 27.942 28.3426 26.7893 29.2759 25.772C30.2186 24.7453 30.6899 23.742 30.6899 22.762C30.6899 22.118 30.5266 21.6047 30.1999 21.222C29.8826 20.83 29.3599 20.634 28.6319 20.634C27.9226 20.634 27.3719 20.858 26.9799 21.306C26.5973 21.7447 26.3826 22.3327 26.3359 23.07H25.3839C25.4399 22.034 25.7573 21.2313 26.3359 20.662C26.9239 20.0833 27.6893 19.794 28.6319 19.794C29.5373 19.794 30.2699 20.0507 30.8299 20.564C31.3899 21.068 31.6699 21.7867 31.6699 22.72C31.6699 23.8493 31.1986 24.946 30.2559 26.01C29.3226 27.0647 28.1699 28.096 26.7979 29.104H31.9779V29.93H25.2999V29.23Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq42);
export default __webpack_public_path__ + "static/media/fq42.53a0ec5c420f5ced312eb4554f1ec3ae.svg";
export { ForwardRef as ReactComponent };